import { c as _c } from "react/compiler-runtime";
import { faroCoreApiClient } from "@api/faro-core-api-client";
import { useErrorContext } from "@context-providers/error-boundary/error-handling-context";
import { Banner, useToast } from "@flat-ui";
import { useAppSelector } from "@store/store-helper";
import { loggedInUserSelector } from "@store/user/user-selector";
import { useCallback, useEffect, useState } from "react";

/** Display state of the resend verification banner */

/** Renders the dialog to remind users to verify their email address or to request a new verification email */
export function ResendVerification() {
  const $ = _c(13);
  const {
    openToast
  } = useToast();
  const {
    handleErrorWithToast
  } = useErrorContext();
  const loggedInUser = useAppSelector(loggedInUserSelector);
  const [bannerDisplayState, setBannerDisplayState] = useState("hidden");
  let t0;
  let t1;
  if ($[0] !== loggedInUser) {
    t0 = () => {
      if (loggedInUser && !loggedInUser.isMailVerified) {
        setBannerDisplayState("emailNotConfirmed");
      }
    };
    t1 = [loggedInUser];
    $[0] = loggedInUser;
    $[1] = t0;
    $[2] = t1;
  } else {
    t0 = $[1];
    t1 = $[2];
  }
  useEffect(t0, t1);
  let t2;
  if ($[3] !== handleErrorWithToast || $[4] !== loggedInUser || $[5] !== openToast) {
    t2 = async () => {
      setBannerDisplayState("hidden");
      if (loggedInUser) {
        ;
        try {
          await faroCoreApiClient.users.resendVerificationMail(loggedInUser.email);
          openToast({
            title: "New verification mail was sent to your mail address"
          });
        } catch (t3) {
          const error = t3;
          handleErrorWithToast({
            id: `resendVerificationEmail-${Date.now().toString()}`,
            title: "Error resending verification email",
            error
          });
          setBannerDisplayState("emailNotConfirmed");
        }
      }
    };
    $[3] = handleErrorWithToast;
    $[4] = loggedInUser;
    $[5] = openToast;
    $[6] = t2;
  } else {
    t2 = $[6];
  }
  const resendVerificationUrl = t2;
  if (bannerDisplayState === "hidden") {
    return null;
  }
  let t3;
  if ($[7] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = () => setBannerDisplayState("hidden");
    $[7] = t3;
  } else {
    t3 = $[7];
  }
  let t4;
  if ($[8] !== resendVerificationUrl) {
    t4 = {
      label: "Resend verification email",
      action: resendVerificationUrl
    };
    $[8] = resendVerificationUrl;
    $[9] = t4;
  } else {
    t4 = $[9];
  }
  let t5;
  if ($[10] === Symbol.for("react.memo_cache_sentinel")) {
    t5 = <div>To continue using Sphere XG, verify your email address. Didn’t get an email?</div>;
    $[10] = t5;
  } else {
    t5 = $[10];
  }
  let t6;
  if ($[11] !== t4) {
    t6 = <Banner variant="warning" title="Unverified email" onClose={t3} action={t4}>{t5}</Banner>;
    $[11] = t4;
    $[12] = t6;
  } else {
    t6 = $[12];
  }
  return t6;
}